export default __webpack_public_path__ + "static/media/astm.25aa0b19.jpg";